import type { CommandShortcut } from '~/lib/stores/command/types';

export class BaseCommand {
  id: string;
  name: string;
  icon?: string;
  shortcuts: CommandShortcut[] = [];

  constructor(details: { id: string; name: string; icon?: string }) {
    this.id = details.id;
    this.name = details.name;
    this.icon = details.icon;
  }
}
